import { store } from '../store/appStore';

export function isNarrowUi() {
  return typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches;
}

export function openSettingsPanel() {
  if (isNarrowUi()) store.set({ settingsOpen: true });
  else store.set({ settingsPanelVisible: true });
  requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
}

export function toggleSettingsPanel() {
  if (isNarrowUi()) {
    store.set({ settingsOpen: !store.getSnapshot().settingsOpen });
  } else {
    store.set({ settingsPanelVisible: !store.getSnapshot().settingsPanelVisible });
  }
  requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
}

export function toggleObjectsPanel() {
  store.set({ objectsPanelVisible: !store.getSnapshot().objectsPanelVisible });
  requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
}

export const APP_NAME = 'Layerforge';
export const APP_TAGLINE = 'Slicer for Bambu Lab';
export const APP_VERSION = '1.5.1';

